import { Icon } from '@chakra-ui/react';

export const CursorClick = (props) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20.046 8.00011C19.4125 6.72102 18.4836 5.61115 17.336 4.76233C16.1884 3.91352 14.8553 3.35015 13.4468 3.11883C12.0383 2.88752 10.5949 2.99491 9.23617 3.43213C7.87741 3.86934 6.64229 4.62381 5.63299 5.63311C4.62369 6.64241 3.86922 7.87753 3.43201 9.23629C2.99479 10.595 2.8874 12.0384 3.11871 13.4469C3.35003 14.8554 3.91339 16.1886 4.76221 17.3361C5.61103 18.4837 6.7209 19.4126 7.99999 20.0461"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5913 13.6329L12.7875 12.0316C12.6822 11.9965 12.5693 11.9915 12.4613 12.017C12.3533 12.0425 12.2545 12.0975 12.176 12.176C12.0976 12.2544 12.0425 12.3532 12.017 12.4612C11.9915 12.5692 11.9966 12.6822 12.0317 12.7874L13.633 17.5913C13.6691 17.6997 13.7356 17.7954 13.8245 17.8672C13.9134 17.939 14.0211 17.9838 14.1346 17.9963C14.2482 18.0087 14.363 17.9884 14.4654 17.9376C14.5677 17.8868 14.6534 17.8077 14.7122 17.7097L15.6826 16.0924C15.7835 15.9242 15.9243 15.7834 16.0925 15.6825L17.7098 14.7121C17.8078 14.6533 17.8869 14.5676 17.9377 14.4653C17.9884 14.3629 18.0088 14.2481 17.9963 14.1346C17.9839 14.021 17.9391 13.9133 17.8673 13.8244C17.7955 13.7355 17.6997 13.6691 17.5913 13.6329V13.6329Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6933 17.6933L15.8623 15.8623"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.43782 15.3804C7.51824 14.4595 7.00193 13.2112 7.00238 11.9098C7.00283 10.6085 7.52 9.3605 8.44022 8.44028C9.36044 7.52006 10.6084 7.00289 11.9098 7.00244C13.2112 7.00199 14.4595 7.5183 15.3803 8.43788"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);
